<template>
  <v-dialog v-model="dialog" max-width="960px" scrollable :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card :rounded="$vuetify.breakpoint.xsOnly ? '0' : 'xl'" class="lgpd-dialog-card">
      <div class="lgpd-dialog-header">
        <v-btn icon color="grey darken-1" @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="lgpd-dialog-content">
        <Lgpd />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Lgpd from '@/views/lgpd.vue'

export default {
  components: {
    Lgpd
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: this.value
    }
  },
  watch: {
    value(val) {
      this.dialog = val
    },
    dialog(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style scoped>
.lgpd-dialog-card {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.lgpd-dialog-header {
  display: flex;
  justify-content: flex-end;
  flex: 0 0 auto;
  padding: 8px 8px 0;
}

.lgpd-dialog-content {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 0 16px 32px !important;
}

@media (min-width: 600px) {
  .lgpd-dialog-content {
    padding: 0 40px 40px !important;
  }
}
</style>
